export const PAYMENT_BOOST_LANG_CODES = [
  'en-US',
  'es-US',
  'be-BY',
  'ru-BY',
  'uk-UA',
  'ru-UA',
  'en-CA',
  'fr-CA',
  'de-CH',
  'fr-CH',
  'it-CH',
  'rm-CH',
  'en-IE',
  'ga-IE',
  'en-GB',
  'cy-GB',
  'gd-GB',
  'sco-GB',
  'nl-NL',
  'de-DE',
  'dsb-DE',
  'hsb-DE',
  'frr-DE',
  'nb-NO',
  'nn-NO'
]

export const PAYMENT_BOOST_SID_CONFIG = [
  { serviceId: 102837, transaction: { amount: 100 } }, // test
  { serviceId: 904933, transaction: { amount: 100 } },
  { serviceId: 904934, transaction: { amount: 100 } },
  { serviceId: 904859, transaction: { amount: 100 } },
  { serviceId: 103452, transaction: { amount: 100 } },
  { serviceId: 103453, transaction: { amount: 100 } },
  { serviceId: 101191, transaction: { amount: 100 } },
  { serviceId: 101196, transaction: { amount: 100 } },
  { serviceId: 101233, transaction: { amount: 100 } },
  { serviceId: 101234, transaction: { amount: 100 } },
  { serviceId: 103463, transaction: { amount: 100 } },
  { serviceId: 104577, transaction: { amount: 100 } },
  { serviceId: 104578, transaction: { amount: 100 } },
  { serviceId: 104342, transaction: { amount: 100 } }
]
